export const PRODUCT_TAG_COLOR_MAP = {
  amber: {
    label: "Amber",
    color: "#d97706",
  },
  orange: {
    label: "Orange",
    color: "#ea580c",
  },
  red: {
    label: "Red",
    color: "#dc2626",
  },
  "light-blue": {
    label: "Light Blue",
    color: "#0ea5e9",
  },
  blue: {
    label: "Blue",
    color: "#1d4ed8",
  },
  "light-green": {
    label: "Light Green",
    color: "#a3e635",
  },
  green: {
    label: "Green",
    color: "#15803d",
  },
  purple: {
    label: "Purple",
    color: "#7e22ce",
  },
  grey: {
    label: "Grey",
    color: "#57534e",
  },
} as const

export type ProductTagColor =
  keyof typeof PRODUCT_TAG_COLOR_MAP

export const productTagColors = Object.keys(
  PRODUCT_TAG_COLOR_MAP
) as Array<ProductTagColor>

export const productTagColorOptions = Object.entries(
  PRODUCT_TAG_COLOR_MAP
).map(([value, { label, color }]) => ({
  value,
  label,
  color,
}))
